import axios from '@/lib/axios';

type SetLensDataInfoParams = {
  specialOrder: {
    productId?: number;
    fc?: string;
    tp?: string;
    cyl?: string;
    dia?: string;
  },
  lensDataInfo: {
    facilityId?: number;
    expectedShipDate: string;
  }
}

const setLensDataInfo = (data: SetLensDataInfoParams) => {
  return axios.post('/facility/orders/set_lens_data_info', data);
}

export default setLensDataInfo;